import { inTimezone, formatLongDate } from '@shared/lib/date-time';

import type { MessengerMessage } from '../model/types';

import { sortByMessageTime } from './compare-message-time';

/**
 * Сгруппировать сообщения по дате (от старых к новым).
 *
 * Чистая функция: сортирует копию по `sent_at ?? created_at` (тай-брейк по id
 * для детерминизма) и группирует по локализованной дате (`ru`, через
 * форматтер `formatLongDate`). Вынесена из `use-messenger-messages`, чтобы
 * переиспользовать для клиентского фильтра ленты по каналу в окне диалога.
 */
export function groupMessagesByDate(
  messages: MessengerMessage[],
  timezone: string | null | undefined,
): Record<string, MessengerMessage[]> {
  // Ключ группы — подпись дня, но формируется она один раз на день, а не на сообщение.
  const days = new Map<string, { label: string; messages: MessengerMessage[] }>();

  sortByMessageTime(messages).forEach((message) => {
    const zoned = inTimezone(message.sent_at ?? message.created_at, timezone);
    const day = zoned?.toPlainDate().toString() ?? '';
    let group = days.get(day);
    if (!group) {
      group = { label: formatLongDate(zoned), messages: [] };
      days.set(day, group);
    }
    group.messages.push(message);
  });

  return Object.fromEntries([...days.values()].map((group) => [group.label, group.messages]));
}
